module.exports = "/img/_/_/_/assets/images/creeper/book/common//47.jpg?a3eb4904f6f803c3bd38ef355ee39b1a";